"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_demi_1 = require("vue-demi");
const use_1 = require("../use");
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
    (0, use_1.useTeleport)();
    const msg = (0, vue_demi_1.ref)('');
    const toastRef = (0, vue_demi_1.ref)(null);
    function open(text, options = {}) {
        const { timeout = 2e3 } = options;
        msg.value = text;
        if (timeout > 0) {
            setTimeout(() => {
                close();
            }, timeout);
        }
    }
    function close() {
        if (toastRef.value) {
            document.body.removeChild(toastRef.value);
        }
    }
    return Object.assign({
        msg,
        toastRef
    }, {
        open,
        close
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9hc3QudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiVG9hc3QudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBSUEsdUNBQStCO0FBQy9CLGdDQUFxQztBQUNyQyxNQUFNLFVBQVUsR0FBRyxFQUFFLENBQUM7QUFDdEIsVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUNwQyxJQUFBLGlCQUFXLEdBQUUsQ0FBQztJQUNkLE1BQU0sR0FBRyxHQUFHLElBQUEsY0FBRyxFQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3BCLE1BQU0sUUFBUSxHQUFHLElBQUEsY0FBRyxFQUFxQixJQUFJLENBQUMsQ0FBQztJQUMvQyxTQUFTLElBQUksQ0FBQyxJQUFZLEVBQUUsT0FBTyxHQUFHLEVBQUU7UUFDdEMsTUFBTSxFQUNKLE9BQU8sR0FBRyxHQUFHLEVBQ2QsR0FBRyxPQUFjLENBQUM7UUFDbkIsR0FBRyxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxPQUFPLEdBQUcsQ0FBQyxFQUFFLENBQUM7WUFDaEIsVUFBVSxDQUFDLEdBQUcsRUFBRTtnQkFDZCxLQUFLLEVBQUUsQ0FBQztZQUNWLENBQUMsRUFBRSxPQUFPLENBQUMsQ0FBQztRQUNkLENBQUM7SUFDSCxDQUFDO0lBQ0QsU0FBUyxLQUFLO1FBQ1osSUFBSSxRQUFRLENBQUMsS0FBSyxFQUFFLENBQUM7WUFDbkIsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQzVDLENBQUM7SUFDSCxDQUFDO0lBQ0QsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ25CLEdBQUc7UUFDSCxRQUFRO0tBQ1QsRUFBRTtRQUNELElBQUk7UUFDSixLQUFLO0tBQ04sQ0FBQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBQ0Ysa0JBQWUsVUFBVSxDQUFDIn0=